import { render, staticRenderFns } from "./VatSales.vue?vue&type=template&id=4261f443&scoped=true&"
import script from "./VatSales.vue?vue&type=script&lang=js&"
export * from "./VatSales.vue?vue&type=script&lang=js&"
import style0 from "./VatSales.vue?vue&type=style&index=0&id=4261f443&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4261f443",
  null
  
)

export default component.exports